import './SummitFees.scss';
import Component from './SummitFees';
export default Component;